<!-- Only Customer Specific JS code here -->
(function() {
  
  $('.search-icon').click(function(event) {
      event.stopPropagation();
    $('.search-form').toggleClass('search-open');
  });
  
  <!-- Collection Filter Functionality --> 
    $('.filter-parent').each(function(index, filterParent) {
        
        let count = 0;
        
        if($(filterParent).find("span.active").length > 0) {
            let parentText = $(filterParent).find('.filtab').text();
            let active_span_text = $(filterParent).find("span.active").text();
            let active_span_html = $(filterParent).find("span.active").html();
            let active_span_link = $(active_span_html).prop('href');
            $(filterParent).children('.filtab').addClass("filter-selected");
            <!--.append(': ' + active_span_text);-->
            $('#selected-filter-div').css('display', 'block');
            $('#selected-filter-div').append(`<a href=${active_span_link}><span class="active">` + parentText + ': ' + active_span_text + ` <p class="close-filter">x</p></span></a>`);
        }
        
        $(filterParent).children('.filtab').on('click', function() {
           let className = $(this).text().replace(':', '').split(' ');
           if($(this).hasClass('onclass')) {
               $('.filtab').removeClass('onclass');
               $(this).removeClass('onclass');
               console.log(className[0])
               $('.' + className[0]).removeClass('onclass');
               $('#filter-div .collection-tags').css('display', 'none');
           } else {
               $('.filtab').removeClass('onclass');
               $(this).addClass('onclass');
               $('.' + className[0]).addClass('onclass');
               let filterHTML = $('.' + className[0]).html();
               $('#filter-div').html(filterHTML);
               $('#filter-div .collection-tags').css('display', 'block');
           }
        });
        
        if($(this).children('div.filter-block').children('div.filter-child').children().length == 0) {
            $(this).addClass('no-filters');
            $(this).hide();
        }
        
    });
    
    if($('.filter-parent').not('.no-filters').length == 0) {
        $('#filter-overall-header').hide();
    }
    
    <!-- Stick Nav on Scroll -->
    if($(window).width() >= 1024) {
      var lastScrollTop = 0;
      $(window).scroll(function(event){
         var st = $(this).scrollTop();
         if (st > lastScrollTop){
             if(st >= 400) {
               $(".sticky-nav").slideDown(300);
             }
         } else {
            if(st <= 399) {
              $(".sticky-nav").slideUp(300);
            }
         }
         lastScrollTop = st;
      });
    }
    
    <!-- Kentucky Facts in Footer -->
    const kentuckyFacts = ["HAPPY BIRTHDAY WAS INVENTED BY THE HILL SISTERS IN LOUISVILLE, KENTUCKY.", "KENTUCKY INVENTED WIFI AND ROBOTS.", "KENTUCKY HAS THE MOST NAVIGABLE WATERWAYS IN THE CONTINENTAL USA.", "THE SWIMSUIT MARK SPITZ WORE IN 72 OLYMPICS WAS MADE IN PARIS, KENTUCKY.", "THERE ARE MORE BARRELS OF BOURBON THAN PEOPLE IN KENTUCKY."]
    $(".fact-punch-text").text(kentuckyFacts[Math.floor(Math.random() * kentuckyFacts.length)]);
    
    $(".ky-fact-punch img").on("click", function() {
        $(".fact-punch-text").text(kentuckyFacts[Math.floor(Math.random() * kentuckyFacts.length)]);
    });
    
    <!-- Infinite Scrolling of Collections/Ajaxinate Plugin -->
    document.addEventListener("DOMContentLoaded", function() {
        var endlessScroll = new Ajaxinate({
            loadingText: '<img src="https://cdn.shopify.com/s/files/1/0066/4947/9229/files/preload.gif?11222871601726170940" />'
        });
    });
    
    <!-- Custom mega menu dropdown --> 
    $("[data-parent='shop']").on('mouseenter', function() {
       $("[data-parent='shop'] .sub-menu-container").show();
    });
    
    $("[data-parent='shop']").on('mouseleave', function() {
       $("[data-parent='shop'] .sub-menu-container").hide();
    });
    
})();
  
  <!--$(".search-form").mouseup(function(e)-->
  <!--  {-->
  <!--      var subject = $(".search-form form"); -->

  <!--      if(e.target.id != subject.attr('class') && !subject.has(e.target).length)-->
  <!--      {-->
  <!--          subject.removeClass('search-open');-->
  <!--      }-->
  <!--  });-->
